import React from "react";
import { Input } from "../../../../components/Input";

/**
 * @desc Input Admin Password.
 */
export const InputAdminPassword = ({ fieldName, ...rest }) => {
  // CONSTANTS ----------------------------------------------------------------
  const errorProps = {
    id: "form-password-error",
  };

  const inputProps = {
    type: "text",
    id: "form-password",
    "aria-required": "true",
    className: "form-control required",
    "aria-describedby": errorProps.id,
    name: "password",
    placeholder: "Type password here...",
    ...rest,
  };

  const labelProps = {
    children: "Password",
    htmlFor: inputProps.id,
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
    fieldName,
  };

  return <Input {...parentProps} />;
};
